import ReactGA from 'react-ga4'

// Initialize Google Analytics only in production
export const initGA = () => {
  const gaId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID
  const isProduction = import.meta.env.PROD

  if (isProduction && gaId) {
    ReactGA.initialize(gaId, {
      gaOptions: {
        siteSpeedSampleRate: 100,
      },
    })
    console.log('Google Analytics initialized:', gaId)
  } else {
    console.log('Google Analytics not initialized (development mode or missing GA ID)')
  }
}

// Track page views
export const trackPageView = (path) => {
  const isProduction = import.meta.env.PROD

  if (isProduction) {
    ReactGA.send({ hitType: 'pageview', page: path })
  }
}

// Track custom events
export const trackEvent = (category, action, label = null, value = null) => {
  const isProduction = import.meta.env.PROD

  if (isProduction) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    })
  }
}
